import React from "react";
import {
  Container,
  Segment,
  Header,
  Icon,
  Grid,
  Card,
  Button,
  Label,
} from "semantic-ui-react";
import { useNavigate } from "react-router-dom";

const accesos = [
  {
    titulo: "Ingreso ST",
    descripcion: "Registrar nuevos equipos ingresados al servicio técnico.",
    icon: "sign-in alternate",
    color: "teal",
    path: "/serviciotecnico/ingreso",
  },
  {
    titulo: "Asignar Técnico",
    descripcion: "Asignar trabajos pendientes a técnicos.",
    icon: "user wrench",
    color: "blue",
    path: "/serviciotecnico/asignar",
  },
  {
    titulo: "Busqueda Ordenes",
    descripcion: "Busqueda y seguimiento de ordenes de servicio.",
    icon: "search",
    color: "orange",
    path: "/reportesst",
  },
  {
    titulo: "Configuracion ST",
    descripcion: "Revisar equipos finalizados por servicio técnico.",
    icon: "setting",
    color: "green",
    path: "/configuracion",
  },
  {
    titulo: "Entregar",
    descripcion: "Gestionar equipos listos para entrega.",
    icon: "truck",
    color: "violet",
    path: "/serviciotecnico/entregas",
  },
  {
    titulo: "Dashboard ST",
    descripcion: "Ver indicadores generales del servicio técnico.",
    icon: "chart bar outline",
    color: "grey",
    path: "/serviciotecnico",
  },
];

const PanelOperativoAdminST = () => {
  const navigate = useNavigate();

  return (
    <Container fluid style={{ padding: 24 }}>
      <Segment
        raised
        style={{
          borderRadius: 18,
          border: "1px solid #e5e7eb",
          boxShadow: "0 14px 35px rgba(15, 23, 42, 0.08)",
          padding: 28,
        }}
      >
        <Header as="h2">
          <Icon name="wrench" color="teal" />
          <Header.Content>
            Servicio Técnico
            <Header.Subheader>
              Panel operativo para administración del servicio técnico
            </Header.Subheader>
          </Header.Content>
        </Header>

        <Label color="teal" basic>
          ADMIN-LMST
        </Label>

        <Grid stackable columns={3} style={{ marginTop: 18 }}>
          {accesos.map((item) => (
            <Grid.Column key={item.titulo}>
              <Card fluid color={item.color}>
                <Card.Content>
                  <Header as="h3">
                    <Icon name={item.icon} color={item.color} />
                    <Header.Content>{item.titulo}</Header.Content>
                  </Header>

                  <p style={{ color: "#64748b", minHeight: 44 }}>
                    {item.descripcion}
                  </p>
                </Card.Content>

                <Card.Content extra>
                  <Button
                    fluid
                    color={item.color}
                    onClick={() => navigate(item.path)}
                  >
                    Abrir
                    <Icon name="arrow right" />
                  </Button>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))}
        </Grid>
      </Segment>
    </Container>
  );
};

export default PanelOperativoAdminST;